<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-wifi title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.maintenance' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.alarm' : 'misc.edition.alarm') | transloco |
              capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">

        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'common.information' | transloco}}</h4>
            <button type="button" pButton pRipple (click)="this.infoExpanded = !this.infoExpanded"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="infoExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="color: var(--custom-gray)">
            </button>
          </div>
          <ng-container *ngIf="infoExpanded">
            <hr>
            <div class="flex">
              <ul>
                <li class="line-height-3">{{'alarmDefinition.description' | transloco}}</li>
                <li class="line-height-3">{{'alarmDefinition.global' | transloco}}</li>
                <li class="line-height-3">{{'alarmDefinition.organizationsAllowed' | transloco}}</li>
                <li class="line-height-3">{{'alarmDefinition.subscription' | transloco}}</li>
                <li class="line-height-3">{{'alarmDefinition.timer' | transloco}}</li>
              </ul>
            </div>
          </ng-container>
        </div>

        <div class="card">
          <form *ngIf="!isAlarmLoading && alarmForm" [formGroup]="alarmForm">
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="name">{{'attribute.name' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <input class="w-full" formControlName="name" id="name" pInputText type="text">
                </div>
                <app-validation-errors [control]="alarmForm.get('name')"></app-validation-errors>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="alarmType">{{'misc.overview.alarmType' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-dropdown [placeholder]="'select.alarmType' | transloco" styleClass="w-full"
                              [options]="this.alarmTypeOptions" [showClear]="true" id="alarmType"
                              formControlName="alarmType" [autoDisplayFirst]="false" optionLabel="label"
                              optionValue="value">
                  </p-dropdown>
                </div>
                <app-validation-errors [control]="alarmForm.get('alarmType')"></app-validation-errors>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="organizationOwner">{{'model.organizationOwner' | transloco}}: (*)</label>
                </div>
                <div class="col-12 form-field">
                  <p-treeSelect [ngModel]="organizationOwner"
                                (ngModelChange)="onOrganizationOwnerChange($event)"
                                [placeholder]="'select.organization' | transloco"
                                [options]="organizationsHierarchy" [ngModelOptions]="{standalone: true}"
                                id="organizationOwner"
                                appendTo="body" [disabled]="this.mode === 'edit'"></p-treeSelect>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="organizationsAllowed">{{'model.organizationsAllowed' | transloco}}:</label>
                </div>
                <div class="col-12 form-field">
                  <p-treeSelect [ngModel]="organizationsAllowed"
                                (ngModelChange)="onOrganizationsAllowedChange($event)"
                                [placeholder]="'select.organizations' | transloco" [propagateSelectionUp]="false"
                                [propagateSelectionDown]="false" display="chip" appendTo="body"
                                [options]="organizationsAllowedHierarchy"
                                [disabled]="this.organizationsAllowedHierarchy.length == 0" [metaKeySelection]="false"
                                selectionMode="checkbox" id="organizationsAllowed"
                                [ngModelOptions]="{standalone: true}">
                  </p-treeSelect>
                </div>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="deviceMeasurement">{{'attribute.sensor' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-dropdown [placeholder]="'select.sensor' | transloco" styleClass="w-full" [filter]="true"
                              optionValue="name" optionLabel="name"
                              [options]="this.deviceMeasurements" [showClear]="true" id="deviceMeasurement"
                              formControlName="deviceMeasurement" [autoDisplayFirst]="false"></p-dropdown>
                </div>
                <app-validation-errors [control]="alarmForm.get('deviceMeasurement')"></app-validation-errors>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="operation">{{'attribute.operation' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-dropdown [placeholder]="'select.operation' | transloco" styleClass="w-full"
                              [options]="operationOptions" [showClear]="true" id="operation"
                              formControlName="operation" [autoDisplayFirst]="false" optionLabel="label"
                              optionValue="value"></p-dropdown>
                </div>
                <app-validation-errors [control]="alarmForm.get('operation')"></app-validation-errors>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'attribute.timer' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <div class="mb-1">
                    <p-radioButton formControlName="timer" [label]="'attribute.withoutTimer' | transloco" name="timer"
                                   [value]="false"></p-radioButton>
                  </div>
                  <div class="p-field-radiobutton margin-top">
                    <p-radioButton formControlName="timer" [label]="'attribute.withTimer' | transloco" name="timer"
                                   [value]="true"></p-radioButton>
                  </div>
                </div>
              </div>
              <div [ngClass]="this.isByteMaskOperation ? 'col-12 md:col-12 lg:col-6': 'col-12 md:col-12 lg:col-6 xl:col-4'">
                <div class="form-field col-12">
                  <label>{{'attribute.value' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <ng-container *ngIf="!this.isByteMaskOperation">
                    <input class="w-full" formControlName="value" pInputText type="text">
                  </ng-container>
                  <ng-container *ngIf="this.isByteMaskOperation">
                    <app-byte-input formControlName="value"></app-byte-input>
                  </ng-container>
                </div>
                <app-validation-errors [control]="alarmForm.get('value')"></app-validation-errors>
              </div>
              <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="withTimerSelected">
                <div class="form-field col-12 flex justify-content-between">
                  <label for="timeWindow">{{'attribute.timeWindow' | transloco}}: (*)</label>
                  <span class="flex flex-column align-content-end font-italic">{{'common.minutesValue' | transloco}}</span>
                </div>
                <div class="col-12">
                  <input class="w-full" formControlName="timeWindow" id="timeWindow" pInputText type="number">
                </div>
                <app-validation-errors [control]="alarmForm.get('timeWindow')"></app-validation-errors>
              </div>
              <div *ngIf="this.isRoot" class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'attribute.global' | transloco}}:</label>
                </div>
                <div class="col-12">
                  <p-checkbox id="global" formControlName="global" binary="true" class="w-full"></p-checkbox>
                </div>
              </div>
            </div>
          </form>
          <div *ngIf="isAlarmLoading || !alarmForm">
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="name">{{'attribute.name' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="alarmType">{{'misc.overview.alarmType' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="organizationOwner">{{'model.organizationOwner' | transloco}}: (*)</label>
                </div>
                <div class="col-12 form-field">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="col-12 form-field">
                  <label for="organizationsAllowed">{{'model.organizationsAllowed' | transloco}}:</label>
                </div>
                <div class="col-12 form-field">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="deviceMeasurement">{{'attribute.sensor' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label for="operation">{{'attribute.operation' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'attribute.timer' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'attribute.value' | transloco}}: (*)</label>
                </div>
                <div class="col-12">
                  <p-skeleton height="2.5rem"></p-skeleton>
                </div>
              </div>

              <div *ngIf="this.isRoot != undefined && this.isRoot" class="col-12 md:col-12 lg:col-6 xl:col-4">
                <div class="form-field col-12">
                  <label>{{'attribute.global' | transloco}}:</label>
                </div>
                <div class="col-12">
                  <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>

          <div class="grid" *ngIf="!isAlarmLoading && alarmForm">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <p-button [label]="'common.cancel' | transloco" (onClick)="cancel()"
                            styleClass="p-button-danger" iconPos="right"></p-button>
                  <p-button [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                            [disabled]="!isValid()" [loading]="persistingChanges" (onClick)="saveAlarm()"
                            styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>

          <div class="grid" *ngIf="isAlarmLoading || alarmForm == null">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <div class="w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                  <div class="w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
